/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import AtomicSDK from '@atomic.io/action-cards-web-sdk';

export const AtomicLastPurchase = () => {
  try {
    AtomicSDK.updateUser({
      profile: {
        flp_last_purchase: new Date().toISOString(),
      },
    });
  } catch (error) {
    console.log(error);
  }
};
